import { useState } from "react";

import { PrimaryButton, TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

export type Props = {
  isOpen: boolean;
  mixToAdoptModalId: number | null | undefined;
  handleConfirmAdoptBudgetMix: (mixId: number) => Promise<void>;
  closeModal: () => void;
};

export const ChangeAdoptedMixModal = ({
  isOpen,
  mixToAdoptModalId,
  handleConfirmAdoptBudgetMix,
  closeModal,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      titleContent={
        <span className="block font-semibold text-xl">
          Change adopted budget?
        </span>
      }
    >
      <div className="flex flex-col justify-between items-start h-[100px]">
        <div className="flex flex-col gap-4 justify-start items-start">
          <span className="block text-xs text-gray+1">
            You can continue to change your budget even after the period begins.
          </span>
        </div>
        <div className="flex justify-end items-center w-full gap-2">
          <TertiaryButton disabled={isLoading} onClick={closeModal}>
            CANCEL
          </TertiaryButton>
          <PrimaryButton
            disabled={isLoading}
            loading={isLoading}
            onClick={async () => {
              if (mixToAdoptModalId) {
                setIsLoading(true);
                await handleConfirmAdoptBudgetMix(mixToAdoptModalId);
                setIsLoading(false);
              }
            }}
          >
            YES, CONTINUE
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};
